import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import NewsRoomsone from "./newsroomspage/NewsRoomsone";
import NewsRoomstwo from "./newsroomspage/NewsRoomstwo";
import HireInnertwelve from "./hireinnerpage/HireInnertwelve";
import HireInnerthirteen from "./hireinnerpage/HireInnerthirteen";
import Hiresectionnine from "./hirepage/Hiresectionnine";
import Loader from "./Loader";
import { apiCall } from "./authentication";

const NewsRooms = () => {
  const [users2, setUsers2] = useState([]);
  const [newssection1, setNewssection1] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [yoastData, setYoastData] = useState({});
  const slug1 = "wp/v2/pages?slug=news-room";
  const type = "get";
  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchPost = async () => {
      try {
        const data = await apiCall(slug1, type);
        setUsers2(data);
        setNewssection1(data[0].acf.common_section[0]);
        setYoastData(data[0].yoast_head_json);
        data[0].acf.common_section.forEach((element) => {
          if (element.acf_fc_layout == "banner_section") {
            setNewssection1(element);
          }
        });
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchPost();
  }, []); // Empty dependency array ensures the effect runs once

  return (
    <>
      <div>
        {isLoading ? (
          <></>
        ) : (
          <div>
            <HelmetProvider>
              <Helmet>
                <title>{yoastData.title}</title>
                <meta name="description" content={yoastData.description} />
                <meta
                  property="og:locale"
                  content="en_US"
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:type"
                  content="article"
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:title"
                  content={yoastData.og_title}
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:description"
                  content={yoastData.og_description}
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:url"
                  content={yoastData.og_url}
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:site_name"
                  content={yoastData.og_site_name}
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="article:modified_time"
                  content={yoastData.article_modified_time}
                  className="yoast-seo-meta-tag"
                />
                <meta
                  property="og:image"
                  content={yoastData.url}
                  className="yoast-seo-meta-tag"
                />
                {/* <meta property="og:image:width" content={yoastData.og_image.width} className="yoast-seo-meta-tag" />
                    <meta property="og:image:height" content={yoastData.og_image.height} className="yoast-seo-meta-tag" /> */}
                {/* <meta property="og:image:type" content={yoastData.og_image.type} className="yoast-seo-meta-tag" />
                    <meta name="twitter:card" content={yoastData.twitter_card} className="yoast-seo-meta-tag" /> */}
                <meta
                  name="twitter:label1"
                  content="Est. reading time"
                  className="yoast-seo-meta-tag"
                />
                <meta
                  name="twitter:data1"
                  content="1 minute"
                  className="yoast-seo-meta-tag"
                />
              </Helmet>
            </HelmetProvider>
            <NewsRoomsone news1data={newssection1} />
            <NewsRoomstwo />
            <HireInnertwelve />
            <HireInnerthirteen />
            <Hiresectionnine />
          </div>
        )}
      </div>
    </>
  );
};

export default NewsRooms;
